import { useQuery } from '@tanstack/react-query';
import { chatbotApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface AdminSqlAuditParams {
  userId?: number;
  from?: Date;
  to?: Date;
  accepted?: boolean;
  page: number;
  pageSize: number;
}

export function useAdminSqlAudit(params: AdminSqlAuditParams) {
  return useQuery({
    queryKey: queryKeys.chatAdmin.sqlAudit(params),
    queryFn: ({ signal }) =>
      chatbotApiClient.getSqlAudit(
        params.userId,
        params.from,
        params.to,
        params.accepted,
        params.page,
        params.pageSize,
        toCancelToken(signal),
      ),
    meta: { errorContext: 'chat SQL audit' },
  });
}
